import {emotionStyled, tokens} from '@packages/utilities/styled';

import {Divider} from '../../Divider';

export const MenuDivider = emotionStyled(Divider)({
  margin: tokens.ui.menu.divider.margin,
});

MenuDivider.displayName = 'MenuDivider';
